import spinner from '../utils/rbmc.spinner';

const myCreditCard = {
    cardToDelete: undefined,

    init() {
        myCreditCard.bindEvents();
        myCreditCard.bindTooltips();
    },

    bindEvents() {
        $(document.body).on('click', '.payment__icon-delete', function () {
            const $this = $(this);
            $('.payment__icon-delete').tooltip('hide');
            $this.tooltip('show');
            myCreditCard.cardToDelete = $(this);
        });

        $(document.body).on('click', '.payment__tooltip-cancel', function () {
            myCreditCard.cardToDelete.tooltip('hide');
        });

        $(document.body).on('click', '.payment__tooltip-confirm', function () {
            myCreditCard.deleteCreditCard(myCreditCard.cardToDelete);
            myCreditCard.cardToDelete.tooltip('hide');
        });

        $(document.body).on('change', 'input[id*="payment__set-default"]', function () {
            myCreditCard.setAsDefaultPaymentCard($(this));
        });
    },

    bindTooltips() {
        const $deleteCard = $('.payment__icon-delete');
        $deleteCard.each(function (i, deleteIcon) {
            const $deleteIcon = $(deleteIcon);
            $deleteIcon.tooltip({
                html:      true,
                container: '.payment-cards',
                title:     myCreditCard.tooltipTemplate(
                        $deleteIcon.data('tooltip-title'),
                        $deleteIcon.data('tooltip-confirm'),
                        $deleteIcon.data('tooltip-cancel'),
                        'payment__confirm-delete'
                ),
                placement: 'top',
                trigger:   'manual'
            });
        })
    },

    tooltipTemplate(title, confirm, cancel, tooltipClass) {
        return `<p>${title}</p>
            <div class="tooltip-buttons ${tooltipClass}">
                <div type="button" class="btn btn-secondary payment__tooltip-cancel">${cancel}</div>
                <div type="button" class="btn btn-primary payment__tooltip-confirm">${confirm}</div>
            </div>`;
    },

    deleteCreditCard($this) {
        $this.parent().animate({opacity: 0.5}, 200);
        spinner.spinnerVisibility(true);
        $.ajax({
            url:     $this.data('remove-url'),
            context: document.body
        }).done(function (response) {
            myCreditCard.refreshCardsSection(response);
        }).always(() => {
            spinner.spinnerVisibility(false);
        });
    },

    setAsDefaultPaymentCard($this) {
        spinner.spinnerVisibility(true);
        $.ajax({
            url:     $this.data('set-default-url'),
            context: document.body
        }).done(function (response) {
            myCreditCard.refreshCardsSection(response);
        }).always(() => {
            spinner.spinnerVisibility(false);
        });
    },

    refreshCardsSection(response) {
        $('.payment__container').replaceWith($(response).find('.payment__container'));
        myCreditCard.bindTooltips();
        spinner.spinnerVisibility(false);

    }
};

$(() => {
    if ($('.page-PaymentDetailsPage').length) {
        myCreditCard.init();
    }
});

export default myCreditCard;
